import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FFCC31",
      d: "m10.363 3.957-8.106 14.06a2.05 2.05 0 0 0-.006 1.98c.166.3.404.552.692.728.289.176.616.271.95.275h16.214a1.86 1.86 0 0 0 .95-.275c.288-.176.526-.427.692-.729a2.05 2.05 0 0 0-.005-1.979l-8.107-14.06a1.95 1.95 0 0 0-.698-.701 1.86 1.86 0 0 0-1.878 0 1.95 1.95 0 0 0-.698.701"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FFCC31",
      "fill-rule": "evenodd",
      d: "M10.808 2.824a2.36 2.36 0 0 1 2.384 0c.362.212.663.516.877.881v.003l8.112 14.066a2.55 2.55 0 0 1 .006 2.463 2.46 2.46 0 0 1-.87.915 2.36 2.36 0 0 1-1.204.348H3.887a2.36 2.36 0 0 1-1.204-.348 2.46 2.46 0 0 1-.87-.915 2.55 2.55 0 0 1 .006-2.463l.004-.007L9.93 3.707l.002-.002a2.45 2.45 0 0 1 .876-.88M12 3.5c-.24 0-.476.064-.687.187a1.45 1.45 0 0 0-.517.521v.001L2.691 18.263a1.55 1.55 0 0 0-.002 1.493c.124.227.302.413.514.543.212.129.45.198.692.201h16.208a1.36 1.36 0 0 0 .692-.201c.212-.13.39-.316.515-.543a1.55 1.55 0 0 0-.003-1.493L13.205 4.21a1.45 1.45 0 0 0-.518-.522A1.36 1.36 0 0 0 12 3.5",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#171717",
      "fill-rule": "evenodd",
      d: "M11 17a1 1 0 1 1 2 0 1 1 0 0 1-2 0M12 14a1 1 0 0 1-1-1V9a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }